// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"84791d50df1724b41802","245":"4031c5fa102458480c74","453":"b02bd0609b11799d59e2"}[chunkId] + ".js";
};